export default __webpack_public_path__ + "static/media/253.66f1c0a0.jpg";